import DocumentRepositoryList from "./pages/DocumentRepositoryList.vue";
import DocumentRepositoryDetail from "./pages/DocumentRepositoryDetail.vue";
export default { DocumentRepositoryList, DocumentRepositoryDetail };